export default __webpack_public_path__ + "static/media/026-tank.14195509.svg";